import { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useFeatureFlagRedux, useOnce } from '../../../hooks';
import { useResponsive } from '../../../hooks/useResponsiveEffect';
import { fetchPaymentSettings } from '../../../modules/provider/PaymentSettings';
import { IPaymentSettingsV3 } from '../../../modules/provider/PaymentSettings.types';
import { NavigationFilterParams } from './types';
import { RootState } from '../../../store/models';
import { PRO_GROWTH_LOANS_TAB } from '../../provider/payments/Loans/constants';

export function useNavigationFilterParams(providerId: number): NavigationFilterParams {
  const [paymentSettings, setPaymentSettings] = useState<IPaymentSettingsV3 | null>(null);
  const responsive = useResponsive();
  const { enabled: isLoansTabEnabled } = useFeatureFlagRedux(PRO_GROWTH_LOANS_TAB);
  const userJoinDate = useSelector<RootState, string>(state => state.user?.date_joined);
  useOnce(async () => {
    setPaymentSettings(await fetchPaymentSettings(providerId));
  }, providerId);
  return {
    isLoansTabEnabled,
    responsive,
    providerPaymentConfig: paymentSettings,
    userJoinDate: moment.utc(userJoinDate).format('YYYY-MM-DD'),
  };
}
